export class RisingEdgeBufferedAction {
    action: (...args: unknown[]) => void;
    options = {};
    currentlyRunning = false;
    pendingExecution = false;
    args = [];
    period = 200;
    /**
     * If false, this will always wait one period before actually triggering
     * @type {boolean}
     */
    risingEdge = true;

    /**
     * If true, this will wait until no more changes are being made to trigger
     * only works if rising edge is false.
     * @type {boolean}
     */
    waitForQuiet = false;

    constructor(action: (...args: unknown[]) => void, period = 200) {
        this.action = action;
        this.period = period;
    }

    _execute(): void {
        this.currentlyRunning = true;
        if (this.risingEdge) {
            this.action(...this.args);
        }
        setTimeout(() => {
            const pendingExecution = this.pendingExecution;
            if (!pendingExecution) {
                this.currentlyRunning = false;
            }
            //If this is a falling edge action
            if (!this.risingEdge) {
                //If we are waiting for quiet and there is no pending task, we should execute
                if (this.waitForQuiet) {
                    if (!pendingExecution) {
                        this.action(...this.args);
                    }
                }
                //If we dont't have to wait for quite, just execute.
                else {
                    this.action(...this.args);
                }
            }

            if (pendingExecution) {
                this.pendingExecution = false;
                this._execute();
            }
        }, this.period);
    }

    trigger(...args: unknown[]): void {
        this.args = args;
        if (!this.currentlyRunning) {
            this._execute();
        } else {
            this.pendingExecution = true;
        }
    }
}
